import { Component, OnInit, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { CvUploadImportResult } from '../../../shared/components/formly-fields';

@Component({
  selector: 'app-modal-student-profile-resume',
  templateUrl: './modal-student-profile-resume.component.html',
  styleUrls: ['./modal-student-profile-resume.component.scss'],
  standalone: false,
})
export class ModalStudentProfileResumeComponent implements OnInit {
  public activeModal = inject(NgbActiveModal);

  /** Injected by ModalService.Modal — the student profile (used for its id). */
  public data: any;

  form = new FormGroup({});
  model: Record<string, unknown> = {};
  fields: FormlyFieldConfig[] = [];

  ngOnInit(): void {
    this.fields = [
      {
        key: 'cv',
        type: 'cv-upload-import',
        props: {
          profileId: this.data?.id,
          secondaryLabel: 'Cancel',
          onSecondary: () => this.activeModal.close(false),
          onComplete: (_r: CvUploadImportResult) => this.activeModal.close(true),
        },
      },
    ];
  }
}
